var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.attrs.class,attrs:{"id":_vm.attrs.id},domProps:{"innerHTML":_vm._s(_vm.profanity ? _vm.filterProfanity(_vm.output) : _vm.output)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }